/**
 * Turkish profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Turkish
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 203
 */

export const TR = {
  "metadata": {
    "name": "Turkish",
    "code": "tr",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 203
  },
  "words": [
    {
      "word": "kahretsin",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "kahrolsun",
        "k4hretsin",
        "kahrolayım"
      ],
      "case_sensitive": false,
      "context_notes": "Mild curse, equivalent to 'damn it' in English",
      "target_type": "general"
    },
    {
      "word": "lanet",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "lanet olsun",
        "l4net",
        "la'net"
      ],
      "case_sensitive": false,
      "context_notes": "Mild religious curse meaning 'curse' or 'damn'",
      "target_type": "general"
    },
    {
      "word": "Allah kahretsin",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [
        "allahkahretsin",
        "allah k4hretsin"
      ],
      "case_sensitive": false,
      "context_notes": "Religious exclamation, mildly offensive",
      "target_type": "general"
    },
    {
      "word": "cehennem",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [
        "cehenneme",
        "c3hennem"
      ],
      "case_sensitive": false,
      "context_notes": "Religious reference to hell, mild profanity",
      "target_type": "general"
    },
    {
      "word": "bok",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "boktan",
        "b0k",
        "bokum",
        "boku",
        "bokunu",
        "boklar"
      ],
      "case_sensitive": false,
      "context_notes": "Common scatological term meaning 'shit'",
      "target_type": "general"
    },
    {
      "word": "pislik",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "pislik",
        "p1slik",
        "pisliği"
      ],
      "case_sensitive": false,
      "context_notes": "Means 'filth' or 'dirt', moderately offensive",
      "target_type": "general"
    },
    {
      "word": "göt",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "götün",
        "götü",
        "götüm",
        "g0t",
        "götveren"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for buttocks",
      "target_type": "general"
    },
    {
      "word": "mal",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "malın",
        "malı",
        "m4l",
        "malsın"
      ],
      "case_sensitive": false,
      "context_notes": "Common insult meaning 'stupid' or 'idiot'",
      "target_type": "individual"
    },
    {
      "word": "salak",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "salağın",
        "salağı",
        "s4lak",
        "salaksın"
      ],
      "case_sensitive": false,
      "context_notes": "Common insult meaning 'stupid' or 'dumb'",
      "target_type": "individual"
    },
    {
      "word": "aptal",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "aptalın",
        "aptalı",
        "4ptal",
        "aptalsın"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'stupid' or 'fool'",
      "target_type": "individual"
    },
    {
      "word": "gerizekalı",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "gerizekalısı",
        "g3rizekalı",
        "geri zekalı"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive term meaning 'retard' or 'backward'",
      "target_type": "individual"
    },
    {
      "word": "dangalak",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "dangalağın",
        "d4ngalak"
      ],
      "case_sensitive": false,
      "context_notes": "Regional insult meaning 'stupid' or 'fool'",
      "target_type": "individual"
    },
    {
      "word": "ibne",
      "severity": 3,
      "categories": [
        "homophobic",
        "sexual"
      ],
      "variations": [
        "ibnesi",
        "1bne",
        "ibnelik"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive homophobic slur",
      "target_type": "individual"
    },
    {
      "word": "piç",
      "severity": 3,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "pici",
        "piçi",
        "p1ç",
        "piçlik"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive term meaning 'bastard'",
      "target_type": "individual"
    },
    {
      "word": "orospu",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "orospusu",
        "orospunun",
        "0rospu",
        "orsp"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive term for prostitute, very derogatory",
      "target_type": "individual"
    },
    {
      "word": "orospu çocuğu",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "gender"
      ],
      "variations": [
        "orospu cocugu",
        "orospucocugu",
        "orospu evladı"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound insult meaning 'son of a bitch'",
      "target_type": "individual"
    },
    {
      "word": "kahpe",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "kahpesi",
        "k4hpe",
        "kahpelik"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women, meaning 'whore' or 'bitch'",
      "target_type": "individual"
    },
    {
      "word": "sürtük",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "sürtüğün",
        "surtuk",
        "s3rtük"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women with sexual implications",
      "target_type": "individual"
    },
    {
      "word": "fahişe",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "fahişesi",
        "f4hişe"
      ],
      "case_sensitive": false,
      "context_notes": "Formal but derogatory term for prostitute",
      "target_type": "individual"
    },
    {
      "word": "kaltak",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "kaltağın",
        "k4ltak"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women, similar to 'bitch'",
      "target_type": "individual"
    },
    {
      "word": "amcık",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "amcığın",
        "amcığı",
        "4mcık",
        "amcık"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar term for female genitalia",
      "target_type": "general"
    },
    {
      "word": "am",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "amın",
        "amı",
        "4m"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for female genitalia",
      "target_type": "general"
    },
    {
      "word": "yarrak",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "yarrağın",
        "yarrağı",
        "y4rrak",
        "yarram"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar term for male genitalia",
      "target_type": "general"
    },
    {
      "word": "sik",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "sikin",
        "siki",
        "s1k",
        "sikm"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for male genitalia",
      "target_type": "general"
    },
    {
      "word": "taşak",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "taşağın",
        "taşağı",
        "t4şak",
        "taşşak"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for testicles",
      "target_type": "general"
    },
    {
      "word": "meme",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "memesi",
        "memeleri",
        "m3me"
      ],
      "case_sensitive": false,
      "context_notes": "Slang term for breast, mildly offensive",
      "target_type": "general"
    },
    {
      "word": "siktir",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "siktiri",
        "s1ktir",
        "siktir git"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissal, equivalent to 'f*ck off'",
      "target_type": "general"
    },
    {
      "word": "sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sikiyim",
        "s1keyim",
        "sikeyim seni"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual threat",
      "target_type": "individual"
    },
    {
      "word": "götüne koyayım",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "gotune koyayim",
        "götünekoyayım"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual threat",
      "target_type": "individual"
    },
    {
      "word": "amına koyayım",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "amina koyayim",
        "aminakoyayim",
        "amk"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual expletive, often abbreviated as 'amk'",
      "target_type": "general"
    },
    {
      "word": "amk",
      "severity": 4,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "amq",
        "4mk",
        "a.m.k"
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviated form of 'amına koyayım', extremely common online",
      "target_type": "general"
    },
    {
      "word": "aq",
      "severity": 3,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "4q",
        "a.q"
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviated vulgar expression",
      "target_type": "general"
    },
    {
      "word": "mk",
      "severity": 3,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "m.k",
        "mk."
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviated vulgar expression",
      "target_type": "general"
    },
    {
      "word": "lan",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "l4n",
        "laan"
      ],
      "case_sensitive": false,
      "context_notes": "Casual address, can be mildly rude depending on context",
      "target_type": "individual"
    },
    {
      "word": "ulan",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "ul4n",
        "ulaan"
      ],
      "case_sensitive": false,
      "context_notes": "Dismissive address, moderately rude",
      "target_type": "individual"
    },
    {
      "word": "herifte",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "herif",
        "h3rif"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for a person, meaning 'guy' or 'fellow'",
      "target_type": "individual"
    },
    {
      "word": "kevaşe",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "kevaşesi",
        "k3vaşe"
      ],
      "case_sensitive": false,
      "context_notes": "Archaic but highly offensive term for prostitute",
      "target_type": "individual"
    },
    {
      "word": "pezevenk",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "pezevengi",
        "p3zevenk"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive term meaning 'pimp' or 'scoundrel'",
      "target_type": "individual"
    },
    {
      "word": "gavat",
      "severity": 3,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "gavatın",
        "g4vat"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive term related to cuckoldry",
      "target_type": "individual"
    },
    {
      "word": "piçkurusu",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "piç kurusu",
        "picurusu"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound insult",
      "target_type": "individual"
    },
    {
      "word": "amına kodumun",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "amina kodumun",
        "aminakodumun"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar compound expletive",
      "target_type": "general"
    },
    {
      "word": "sikik",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "s1kik",
        "sikigi"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar adjective meaning 'f*cked' or 'screwed'",
      "target_type": "general"
    },
    {
      "word": "züppe",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "züppesi",
        "z3ppe"
      ],
      "case_sense": false,
      "context_notes": "Insult meaning 'snob' or 'pretentious person'",
      "target_type": "individual"
    },
    {
      "word": "namussuz",
      "severity": 3,
      "categories": [
        "honor",
        "family"
      ],
      "variations": [
        "namussuzu",
        "n4mussuz"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive attack on honor, meaning 'dishonorable'",
      "target_type": "individual"
    },
    {
      "word": "şerefsiz",
      "severity": 3,
      "categories": [
        "honor"
      ],
      "variations": [
        "şerefsizi",
        "ş3refsiz",
        "serefsiz"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive attack on honor, meaning 'shameless'",
      "target_type": "individual"
    },
    {
      "word": "alçak",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "alçağın",
        "4lçak"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'lowlife' or 'despicable'",
      "target_type": "individual"
    },
    {
      "word": "köpek",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "köpeği",
        "k0pek"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'dog', moderately offensive",
      "target_type": "individual"
    },
    {
      "word": "domuz",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "domuzu",
        "d0muz"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'pig', can be religiously offensive",
      "target_type": "individual"
    },
    {
      "word": "eşek",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "eşeği",
        "3şek"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'donkey' or 'ass'",
      "target_type": "individual"
    },
    {
      "word": "it",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "iti",
        "1t"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'mutt' or 'cur'",
      "target_type": "individual"
    },
    {
      "word": "kahbe evladı",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "gender"
      ],
      "variations": [
        "kahbe evladi",
        "kahbeevladi"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound family insult",
      "target_type": "individual"
    },
    {
      "word": "anasını sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "anasini sikeyim",
        "anasinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive family-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "bacını sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "bacini sikeyim",
        "bacinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive family-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "karını sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "karini sikeyim",
        "karinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive family-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "götlek",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual"
      ],
      "variations": [
        "götleği",
        "g0tlek"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar insult related to buttocks",
      "target_type": "individual"
    },
    {
      "word": "sikko",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "s1kko",
        "sikkosu"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissive term",
      "target_type": "general"
    },
    {
      "word": "dalyarak",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "d4lyarak",
        "dal yarrak"
      ],
      "case_sensitive": false,
      "context_notes": "Compound vulgar insult combining 'branch' and male genitalia",
      "target_type": "individual"
    },
    {
      "word": "ananı sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "anani sikeyim",
        "ananisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive mother-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "siktiğimin",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "siktimin",
        "siktigimin"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar possessive form",
      "target_type": "general"
    },
    {
      "word": "amına koyduğumun",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "amina koydugumun",
        "aminakoydugumun"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar possessive form",
      "target_type": "general"
    },
    {
      "word": "götveren",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "homophobic"
      ],
      "variations": [
        "göt veren",
        "g0tveren"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive homophobic sexual insult",
      "target_type": "individual"
    },
    {
      "word": "göt lalesi",
      "severity": 3,
      "categories": [
        "anatomical",
        "homophobic"
      ],
      "variations": [
        "gotlalesi",
        "göt l4lesi"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive homophobic insult meaning 'ass tulip'",
      "target_type": "individual"
    },
    {
      "word": "oç",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "abbreviation"
      ],
      "variations": [
        "0ç",
        "o.ç",
        "oc"
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviated form of 'orospu çocuğu', extremely offensive",
      "target_type": "individual"
    },
    {
      "word": "sg",
      "severity": 3,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "s.g",
        "sg."
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviated form of 'siktir git'",
      "target_type": "individual"
    },
    {
      "word": "sikerim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "s1kerim",
        "sikerim seni"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar sexual threat meaning 'I'll f*ck'",
      "target_type": "individual"
    },
    {
      "word": "sikişmek",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sikişme",
        "s1kişmek"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for sexual intercourse",
      "target_type": "general"
    },
    {
      "word": "sikmek",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sikme",
        "s1kmek"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar term for sexual intercourse",
      "target_type": "general"
    },
    {
      "word": "andaval",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "andavalın",
        "4ndaval"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'idiot' or 'fool'",
      "target_type": "individual"
    },
    {
      "word": "aşüfte",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "aşüftesi",
        "4şüfte"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'slut' or 'loose woman'",
      "target_type": "individual"
    },
    {
      "word": "avanak",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "avanağın",
        "4vanak"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'gullible fool'",
      "target_type": "individual"
    },
    {
      "word": "beyin yoksunu",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "beyin yok",
        "beyinyoksunu"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'brainless'",
      "target_type": "individual"
    },
    {
      "word": "beyinsiz",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "beyinsizsın",
        "b3yinsiz"
      ],
      "case_sensitive": false,
      "context_notes": "Common insult meaning 'brainless' or 'stupid'",
      "target_type": "individual"
    },
    {
      "word": "cibiliyetini sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "cibiliyetini sikeyim",
        "cibiliyetinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your character'",
      "target_type": "individual"
    },
    {
      "word": "çüş",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "çuş",
        "çüüş"
      ],
      "case_sensitive": false,
      "context_notes": "Mild exclamation like 'wow' or 'damn'",
      "target_type": "general"
    },
    {
      "word": "deli",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "delisın",
        "d3li"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult meaning 'crazy' or 'insane'",
      "target_type": "individual"
    },
    {
      "word": "denyo",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "denyosun",
        "d3nyo"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'idiot' or 'fool'",
      "target_type": "individual"
    },
    {
      "word": "dingil",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "dingilsin",
        "d1ngil"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'stupid person'",
      "target_type": "individual"
    },
    {
      "word": "döl",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "dölü",
        "d0l"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for semen",
      "target_type": "general"
    },
    {
      "word": "döl israfı",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "dol israfi",
        "dölisrafı"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive insult meaning 'waste of semen'",
      "target_type": "individual"
    },
    {
      "word": "ebleh",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "eblehi",
        "3bleh"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'idiot'",
      "target_type": "individual"
    },
    {
      "word": "embesil",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "embesili",
        "3mbesil"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'imbecile'",
      "target_type": "individual"
    },
    {
      "word": "enayi",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "enayisin",
        "3nayi"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'sucker' or 'fool'",
      "target_type": "individual"
    },
    {
      "word": "eşşek",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "eşşeği",
        "3şşek"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult, variant of 'eşek' (donkey)",
      "target_type": "individual"
    },
    {
      "word": "eşşeoğlueşşek",
      "severity": 3,
      "categories": [
        "animal",
        "insult",
        "family"
      ],
      "variations": [
        "eşşek oğlu eşşek",
        "essekogluessek"
      ],
      "case_sensitive": false,
      "context_notes": "Compound insult meaning 'son of a donkey'",
      "target_type": "individual"
    },
    {
      "word": "ezik",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "eziksin",
        "3zik"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'loser' or 'crushed'",
      "target_type": "individual"
    },
    {
      "word": "fallik",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "falliği",
        "f4llik"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'slut'",
      "target_type": "individual"
    },
    {
      "word": "gerzek",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "gerzeği",
        "g3rzek"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'idiot' or 'fool'",
      "target_type": "individual"
    },
    {
      "word": "haysiyetsiz",
      "severity": 3,
      "categories": [
        "honor"
      ],
      "variations": [
        "haysiyetsizsın",
        "h4ysiyetsiz"
      ],
      "case_sensitive": false,
      "context_notes": "Honor-based insult meaning 'dishonorable'",
      "target_type": "individual"
    },
    {
      "word": "hayvan",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "hayvanın",
        "h4yvan"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult, derogatory",
      "target_type": "individual"
    },
    {
      "word": "hıyar",
      "severity": 2,
      "categories": [
        "general",
        "insult",
        "sexual"
      ],
      "variations": [
        "hıyarın",
        "hiyar"
      ],
      "case_sensitive": false,
      "context_notes": "Slang meaning 'cucumber', used for 'idiot' or as vulgar slang",
      "target_type": "individual"
    },
    {
      "word": "itoğlu it",
      "severity": 3,
      "categories": [
        "animal",
        "insult",
        "family"
      ],
      "variations": [
        "it oğlu it",
        "itoglu it"
      ],
      "case_sensitive": false,
      "context_notes": "Compound insult meaning 'son of a dog'",
      "target_type": "individual"
    },
    {
      "word": "kahbe",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "kahbesi",
        "k4hbe"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 'kahpe', derogatory for women meaning 'whore'",
      "target_type": "individual"
    },
    {
      "word": "kancık",
      "severity": 3,
      "categories": [
        "sexual",
        "gender",
        "animal"
      ],
      "variations": [
        "kancığın",
        "k4ncık"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'bitch' (female dog)",
      "target_type": "individual"
    },
    {
      "word": "kaşar",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "kaşarın",
        "k4şar"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women meaning 'slut' or 'bitch'",
      "target_type": "individual"
    },
    {
      "word": "kavat",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "kavatın",
        "k4vat"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive term meaning 'pimp' or 'cuckold'",
      "target_type": "individual"
    },
    {
      "word": "kıç",
      "severity": 2,
      "categories": [
        "anatomical"
      ],
      "variations": [
        "kıçın",
        "kıcın",
        "k1ç"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for 'ass' or 'butt'",
      "target_type": "general"
    },
    {
      "word": "kolpa",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "kolpacı",
        "k0lpa"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'fake' or 'phony'",
      "target_type": "individual"
    },
    {
      "word": "kürt",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs"
      ],
      "variations": [
        "kürdü",
        "k3rt"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur, highly offensive when used derogatorily",
      "target_type": "individual"
    },
    {
      "word": "lağım faresi",
      "severity": 3,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "lağımfaresi",
        "lagim faresi"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive insult meaning 'sewer rat'",
      "target_type": "individual"
    },
    {
      "word": "lavuk",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "lavuğun",
        "l4vuk"
      ],
      "case_sensitive": false,
      "context_notes": "Casual term for 'guy', can be derogatory depending on context",
      "target_type": "individual"
    },
    {
      "word": "malafat",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "malafatın",
        "m4lafat"
      ],
      "case_sensitive": false,
      "context_notes": "Slang for male genitalia",
      "target_type": "general"
    },
    {
      "word": "manda",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "mandanın",
        "m4nda"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'buffalo'",
      "target_type": "individual"
    },
    {
      "word": "manyak",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "manyağın",
        "m4nyak"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'crazy' or 'maniac'",
      "target_type": "individual"
    },
    {
      "word": "moruk",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "moruğun",
        "m0ruk"
      ],
      "case_sensitive": false,
      "context_notes": "Term for 'old man', can be insulting depending on context",
      "target_type": "individual"
    },
    {
      "word": "okuz",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "okuzun",
        "0kuz"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'ox'",
      "target_type": "individual"
    },
    {
      "word": "orospu evladı",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "gender"
      ],
      "variations": [
        "orospu evladi",
        "orospuevladi"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound insult meaning 'son of a whore'",
      "target_type": "individual"
    },
    {
      "word": "otuz birci",
      "severity": 2,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "otuzbirci",
        "31ci"
      ],
      "case_sensitive": false,
      "context_notes": "Insulting term meaning 'masturbator'",
      "target_type": "individual"
    },
    {
      "word": "öküz",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "öküzün",
        "0küz"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'ox', used for rude guys",
      "target_type": "individual"
    },
    {
      "word": "puşt",
      "severity": 3,
      "categories": [
        "homophobic",
        "sexual"
      ],
      "variations": [
        "puştun",
        "p3şt"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'coward' or homophobic slur",
      "target_type": "individual"
    },
    {
      "word": "serefsiz",
      "severity": 3,
      "categories": [
        "honor"
      ],
      "variations": [
        "serefsizi",
        "s3refsiz"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 'şerefsiz', honor-based insult meaning 'shameless'",
      "target_type": "individual"
    },
    {
      "word": "sıçan",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "sıçanın",
        "siçan"
      ],
      "case_sensitive": false,
      "context_notes": "Scatological insult meaning 'tiny piece of shit'",
      "target_type": "individual"
    },
    {
      "word": "sıçmak",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "sıçayım",
        "sıçma"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term meaning 'to shit'",
      "target_type": "general"
    },
    {
      "word": "siçan",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "sicanın",
        "s1çan"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 'sıçan', scatological insult",
      "target_type": "individual"
    },
    {
      "word": "siktir git",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "sktir git",
        "siktirgit"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissal command meaning 'fuck off'",
      "target_type": "individual"
    },
    {
      "word": "siktimin",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "siktmin",
        "s1ktimin"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 'siktiğimin', extremely vulgar possessive",
      "target_type": "general"
    },
    {
      "word": "sokuk",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "sokuğun",
        "s0kuk"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'asshole'",
      "target_type": "individual"
    },
    {
      "word": "şırfıntı",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "şırfıntının",
        "sirfinti"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women meaning 'slut' or 'loose woman'",
      "target_type": "individual"
    },
    {
      "word": "taşşak",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "taşşağın",
        "t4şşak"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 'taşak', vulgar term for testicles",
      "target_type": "general"
    },
    {
      "word": "tipini sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "tipini sikeyim",
        "tipinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your face'",
      "target_type": "individual"
    },
    {
      "word": "tost yapmak",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "tost yapmak",
        "tostyapmak"
      ],
      "case_sensitive": false,
      "context_notes": "Slang expression 'make a toast', can have vulgar sexual context",
      "target_type": "general"
    },
    {
      "word": "uyuz",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "uyuzsun",
        "uyuzun"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'scabies' or 'annoying person'",
      "target_type": "individual"
    },
    {
      "word": "veled",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "veledin",
        "v3led"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'brat' or 'immature'",
      "target_type": "individual"
    },
    {
      "word": "yarak",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "yarağın",
        "y4rak"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 'yarrak', extremely vulgar term for male genitalia",
      "target_type": "general"
    },
    {
      "word": "yavşak",
      "severity": 3,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "yavşağın",
        "y4vşak"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive insult meaning 'punk' or 'scumbag'",
      "target_type": "individual"
    },
    {
      "word": "yosma",
      "severity": 3,
      "categories": [
        "sexual",
        "gender"
      ],
      "variations": [
        "yosmanın",
        "y0sma"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for women meaning 'loose woman'",
      "target_type": "individual"
    },
    {
      "word": "ağzına sıçayım",
      "severity": 4,
      "categories": [
        "scatological"
      ],
      "variations": [
        "agzina sicayim",
        "ağzınasıçayım"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive expression meaning 'I'll shit in your mouth'",
      "target_type": "individual"
    },
    {
      "word": "ağzına tüküreyim",
      "severity": 3,
      "categories": [
        "general"
      ],
      "variations": [
        "agzina tukureyim",
        "ağzınatüküreyim"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive expression meaning 'I'll spit in your mouth'",
      "target_type": "individual"
    },
    {
      "word": "Allah belanı versin",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [
        "allah belani versin",
        "allahbelanıversin"
      ],
      "case_sensitive": false,
      "context_notes": "Religious curse meaning 'May God give you trouble'",
      "target_type": "individual"
    },
    {
      "word": "allahını sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "religious"
      ],
      "variations": [
        "allahini sikeyim",
        "allahinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive religious curse meaning 'fuck your god'",
      "target_type": "individual"
    },
    {
      "word": "ananın amı",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "anatomical"
      ],
      "variations": [
        "ananin ami",
        "ananınami"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar family-targeted insult",
      "target_type": "individual"
    },
    {
      "word": "ananın amına koyayım",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "anatomical"
      ],
      "variations": [
        "ananin amina koyayim",
        "ananınaminakoyayım"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar mother-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "annenin amı",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "anatomical"
      ],
      "variations": [
        "annenin ami",
        "anneninami"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar family-targeted insult",
      "target_type": "individual"
    },
    {
      "word": "amlı",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "amlısın",
        "4mlı"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar adjective meaning 'having pussy'",
      "target_type": "general"
    },
    {
      "word": "ananı sikerim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "anani sikerim",
        "ananısikerim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive mother-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "anneni sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "anneni sikeyim",
        "annenisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive mother-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "babanı sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "babani sikeyim",
        "babanısikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive father-targeted sexual threat",
      "target_type": "individual"
    },
    {
      "word": "beyinini sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "beyinini sikeyim",
        "beyininisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your brain'",
      "target_type": "individual"
    },
    {
      "word": "ciğerini sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "cigerini sikeyim",
        "ciğerinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your liver'",
      "target_type": "individual"
    },
    {
      "word": "dalyarrak",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "insult"
      ],
      "variations": [
        "dal yarrak",
        "d4lyarrak"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar compound meaning 'branch dick'",
      "target_type": "individual"
    },
    {
      "word": "ebesinin amı",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "anatomical"
      ],
      "variations": [
        "ebesinin ami",
        "ebesininami"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar family-targeted insult (grandmother)",
      "target_type": "individual"
    },
    {
      "word": "göt contası",
      "severity": 3,
      "categories": [
        "anatomical",
        "sexual"
      ],
      "variations": [
        "got contasi",
        "götcontası"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar insult meaning 'ass gasket'",
      "target_type": "individual"
    },
    {
      "word": "götünü sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "gotunu sikeyim",
        "götünüsikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual threat",
      "target_type": "individual"
    },
    {
      "word": "götünü yiyim",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "gotunu yiyim",
        "götünüyiyim"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar sexual expression meaning 'I'll eat your ass'",
      "target_type": "individual"
    },
    {
      "word": "hay amına koyayım",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "hay amina koyayim",
        "hayaminakoyayım"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar general expletive like 'damn, fuck it'",
      "target_type": "general"
    },
    {
      "word": "kafanı sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "kafani sikeyim",
        "kafanısikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your head'",
      "target_type": "individual"
    },
    {
      "word": "kanırtmak",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "kanirt",
        "k4nırtmak"
      ],
      "case_sensitive": false,
      "context_notes": "Slang meaning 'to piss off'",
      "target_type": "general"
    },
    {
      "word": "kelleni koparırım",
      "severity": 4,
      "categories": [
        "violent"
      ],
      "variations": [
        "kelleni koparirim",
        "kellenikoparırım"
      ],
      "case_sensitive": false,
      "context_notes": "Violent threat meaning 'I'll cut off your head'",
      "target_type": "individual"
    },
    {
      "word": "leş gibi",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "les gibi",
        "leşgibi"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'like a corpse' or 'disgusting'",
      "target_type": "general"
    },
    {
      "word": "manyağın teki",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "manyagin teki",
        "manyağınteki"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'one of the crazies'",
      "target_type": "individual"
    },
    {
      "word": "nankör",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "nankörün",
        "n4nkör"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'ungrateful bastard'",
      "target_type": "individual"
    },
    {
      "word": "orospu çocuğunun fırlattığı",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "orospu cocugunun firlatigi",
        "orospuçocuğununfırlattığı"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound insult",
      "target_type": "individual"
    },
    {
      "word": "ruhunu sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ruhunu sikeyim",
        "ruhunusikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your soul'",
      "target_type": "individual"
    },
    {
      "word": "seni sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "seni sikeyim",
        "senisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual threat meaning 'I'll fuck you'",
      "target_type": "individual"
    },
    {
      "word": "senin amına koyayım",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "senin amina koyayim",
        "seninaminakoyayım"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual expletive",
      "target_type": "individual"
    },
    {
      "word": "senin ben amına koyayım",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "senin ben amina koyayim",
        "seninbenaminakoyayım"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar extended sexual expletive",
      "target_type": "individual"
    },
    {
      "word": "sıçayım ağzına",
      "severity": 4,
      "categories": [
        "scatological"
      ],
      "variations": [
        "sicayim agzina",
        "sıçayımagzına"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive scatological threat",
      "target_type": "individual"
    },
    {
      "word": "sifatını sikeyim",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sifatini sikeyim",
        "sifatınısikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar expression meaning 'fuck your face'",
      "target_type": "individual"
    },
    {
      "word": "sikimin keyfine bak",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "sikimin keyfine bak",
        "sikiminkeyfinebak"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissive expression",
      "target_type": "individual"
    },
    {
      "word": "sikimin teki",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "sikimin teki",
        "sikiminteki"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar insult meaning 'worthless person'",
      "target_type": "individual"
    },
    {
      "word": "siktirgit",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "siktir git",
        "s1ktirgit"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissal, one-word form of 'siktir git'",
      "target_type": "individual"
    },
    {
      "word": "sokayım",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sok4yım",
        "sokayim"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar sexual expression meaning 'I'll stick it in'",
      "target_type": "individual"
    },
    {
      "word": "sülaleni sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "sulaleni sikeyim",
        "sülalenisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive family-targeted threat meaning 'fuck your lineage'",
      "target_type": "individual"
    },
    {
      "word": "taşşağıma bak",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "tassagima bak",
        "taşşağımabak"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissive expression",
      "target_type": "individual"
    },
    {
      "word": "yarra yedin",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "yarra yedin",
        "yarrayedin"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar expression meaning 'you're fucked/in trouble'",
      "target_type": "individual"
    },
    {
      "word": "yarrağımı ye",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "yarragimi ye",
        "yarrağımıye"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual command meaning 'eat my dick'",
      "target_type": "individual"
    },
    {
      "word": "yarrağıma bak",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical"
      ],
      "variations": [
        "yarragima bak",
        "yarrağımabak"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar dismissive expression",
      "target_type": "individual"
    },
    {
      "word": "zürriyetini sikeyim",
      "severity": 4,
      "categories": [
        "sexual",
        "family"
      ],
      "variations": [
        "zurriyetini sikeyim",
        "zürriyetinisikeyim"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive family-targeted threat meaning 'fuck your offspring'",
      "target_type": "individual"
    },
    {
      "word": "a.m.k",
      "severity": 4,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "amk",
        "a m k"
      ],
      "case_sensitive": false,
      "context_notes": "Spaced abbreviation of 'amına koyayım'",
      "target_type": "general"
    },
    {
      "word": "amq",
      "severity": 4,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "4mq",
        "a.m.q"
      ],
      "case_sensitive": false,
      "context_notes": "Variant abbreviation of 'amk'",
      "target_type": "general"
    },
    {
      "word": "a.q",
      "severity": 3,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "aq",
        "a q"
      ],
      "case_sensitive": false,
      "context_notes": "Spaced variant of 'aq'",
      "target_type": "general"
    },
    {
      "word": "o.ç",
      "severity": 4,
      "categories": [
        "sexual",
        "family",
        "abbreviation"
      ],
      "variations": [
        "oç",
        "o ç"
      ],
      "case_sensitive": false,
      "context_notes": "Spaced variant of 'oç'",
      "target_type": "individual"
    },
    {
      "word": "s.g",
      "severity": 3,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "sg",
        "s g"
      ],
      "case_sensitive": false,
      "context_notes": "Spaced variant of 'sg' (siktir git)",
      "target_type": "individual"
    },
    {
      "word": "mk.",
      "severity": 3,
      "categories": [
        "sexual",
        "abbreviation"
      ],
      "variations": [
        "mk",
        "m.k"
      ],
      "case_sensitive": false,
      "context_notes": "Variant with period of 'mk'",
      "target_type": "general"
    },
    {
      "word": "abanoz",
      "severity": 3,
      "categories": [
        "hate_speech",
        "slurs"
      ],
      "variations": [
        "abanozu",
        "4banoz"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur meaning 'ebony', offensive",
      "target_type": "individual"
    },
    {
      "word": "abazan",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "abazanın",
        "4bazan"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'horny person' or 'pervert'",
      "target_type": "individual"
    },
    {
      "word": "ahraz",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "ahrazın",
        "4hraz"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'stupid' or 'retarded'",
      "target_type": "individual"
    },
    {
      "word": "aqıllı",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "akıllı",
        "4qıllı"
      ],
      "case_sensitive": false,
      "context_notes": "Sarcastic use of 'smart', mildly insulting",
      "target_type": "individual"
    },
    {
      "word": "asalak",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "asalağın",
        "4salak"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'parasite'",
      "target_type": "individual"
    },
    {
      "word": "ayı",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "ayının",
        "4yı"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'bear', implies clumsy or stupid",
      "target_type": "individual"
    },
    {
      "word": "bacaksız",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "bacaksızın",
        "b4caksız"
      ],
      "case_sensitive": false,
      "context_notes": "Insulting term meaning 'legless'",
      "target_type": "individual"
    },
    {
      "word": "bedava",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "bedavacı",
        "b3dava"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult meaning 'free' or 'cheapskate'",
      "target_type": "individual"
    },
    {
      "word": "beş parasız",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "bes parasiz",
        "beşparasız"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'penniless'",
      "target_type": "individual"
    },
    {
      "word": "beyinsiz kafa",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "beyinsiz kafa",
        "beyinsizkafa"
      ],
      "case_sensitive": false,
      "context_notes": "Compound insult meaning 'brainless head'",
      "target_type": "individual"
    },
    {
      "word": "bıçkın",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "bıçkının",
        "bickin"
      ],
      "case_sensitive": false,
      "context_notes": "Term for 'thug' or 'tough guy', can be negative",
      "target_type": "individual"
    },
    {
      "word": "bit",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "biti",
        "b1t"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'louse', worthless person",
      "target_type": "individual"
    },
    {
      "word": "boş",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "boşsun",
        "b0ş"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'empty' or 'worthless'",
      "target_type": "individual"
    },
    {
      "word": "çakal",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "çakalın",
        "ç4kal"
      ],
      "case_sensitive": false,
      "context_notes": "Animal insult meaning 'jackal', implies opportunist",
      "target_type": "individual"
    },
    {
      "word": "çapsız",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "çapsızın",
        "c4psız"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'incompetent'",
      "target_type": "individual"
    },
    {
      "word": "çıyan",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "çıyanın",
        "ciyan"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'scorpion', venomous person",
      "target_type": "individual"
    },
    {
      "word": "çöp",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "çöpün",
        "c0p"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'garbage'",
      "target_type": "individual"
    },
    {
      "word": "dalga geçmek",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "dalga gec",
        "dalgageçmek"
      ],
      "case_sensitive": false,
      "context_notes": "Phrase meaning 'to mock', context dependent",
      "target_type": "general"
    },
    {
      "word": "deli dana",
      "severity": 2,
      "categories": [
        "animal",
        "insult"
      ],
      "variations": [
        "deli dana",
        "delidana"
      ],
      "case_sensitive": false,
      "context_notes": "Compound insult meaning 'crazy calf'",
      "target_type": "individual"
    },
    {
      "word": "dengesiz",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "dengesizsin",
        "d3ngesiz"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'unbalanced'",
      "target_type": "individual"
    },
    {
      "word": "dürzü",
      "severity": 3,
      "categories": [
        "hate_speech",
        "slurs"
      ],
      "variations": [
        "dürzüsün",
        "durzu"
      ],
      "case_sensitive": false,
      "context_notes": "Offensive ethnic/religious slur",
      "target_type": "individual"
    },
    {
      "word": "fındık kafalı",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "findik kafali",
        "fındıkkafalı"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'peanut head'",
      "target_type": "individual"
    },
    {
      "word": "fondip",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "fondipsin",
        "f0ndip"
      ],
      "case_sensitive": false,
      "context_notes": "Slang insult meaning 'idiot'",
      "target_type": "individual"
    },
    {
      "word": "godo",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "godosun",
        "g0do"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for provincial or backward person",
      "target_type": "individual"
    },
    {
      "word": "göt herif",
      "severity": 3,
      "categories": [
        "anatomical",
        "insult"
      ],
      "variations": [
        "got herif",
        "götherif"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar compound insult meaning 'ass guy'",
      "target_type": "individual"
    },
    {
      "word": "hırsız",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "hırsızın",
        "hirsiz"
      ],
      "case_sensitive": false,
      "context_notes": "Insulting term meaning 'thief'",
      "target_type": "individual"
    },
    {
      "word": "hödük",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "hödüğün",
        "hoduk"
      ],
      "case_sensitive": false,
      "context_notes": "Insulting term meaning 'bumpkin' or 'peasant'",
      "target_type": "individual"
    }
  ]
} as const

export type TRType = typeof TR
